import { BRITE_CLIENT_SCRIPT_URL } from './bank.constants';

declare global {
  interface Window {
    Brite?: any;
  }
}

let briteScriptPromise: Promise<void> | null = null;

// Singleton script injector so multiple mounts across surfaces don't
// re-inject client.js.
export function loadBriteClient(): Promise<void> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Brite client can only load in a browser environment'));
  }
  if (window.Brite) {
    return Promise.resolve();
  }
  if (briteScriptPromise) {
    return briteScriptPromise;
  }

  briteScriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>('script[data-brite-client]');
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject(new Error('Failed to load Brite client script')));
      return;
    }

    const script = document.createElement('script');
    script.src = BRITE_CLIENT_SCRIPT_URL;
    script.async = true;
    script.setAttribute('data-brite-client', 'true');
    script.onload = () => resolve();
    script.onerror = () => {
      briteScriptPromise = null;
      reject(new Error('Failed to load Brite client script'));
    };
    document.head.appendChild(script);
  });

  return briteScriptPromise;
}
